<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "app",
        data() {
            return {
            }
        },
        created() {
        },
        methods: {


            voter_search: function () {
                (function (that) {

                    var data = {
                        firstName: that.first_name,
                        lastName: that.last_name,
                        birthDate: that.birth_date,
                        addressId: that.address.id,
                        action: 'voter-lookup'
                    };
                    axios.get(this.$APP_API_URL, { params: data })
                        .then(function (response) {
                            if (response && response.data) {
                                that.response = response.data;
                            } else {
                                that.register = true;
                            }
                        })
                        .catch(function () {
                            //that.errors.push(tran('error_message'));
                            that.errors.push('error_message');
                        })
                })(this);

            },
        }
    }
</script>
